import domReady from "@wordpress/dom-ready";
import { customFadeInTopElem } from "assets/animations";

const animateTextItems = () => {
	const items = document.querySelectorAll(
		".wp-block-theme-blocks-text-list .text-list__item",
	);

	const parentElem = document.querySelector(
		".wp-block-theme-blocks-text-list .text-list__content",
	);

	items?.forEach((item, index) => {
		if (!item.classList.contains("animated"))
			customFadeInTopElem({
				elem: item,
				parentElem,
				index,
				start: "top center",
			});
	});
};

domReady(() => {
	animateTextItems();
});
